const ProductCardFilStars = (props) => (
  <svg
    width={86}
    height={16}
    viewBox='0 0 86 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M3.636 15.231L5.562 9.50705L0.918 6.39305H6.606L8.64 0.255048L10.71 6.39305H16.362L11.718 9.50705L13.68 15.231L8.64 11.577L3.636 15.231ZM20.9153 15.231L22.8413 9.50705L18.1973 6.39305H23.8853L25.9193 0.255048L27.9893 6.39305H33.6413L28.9973 9.50705L30.9593 15.231L25.9193 11.577L20.9153 15.231ZM38.1946 15.231L40.1206 9.50705L35.4766 6.39305H41.1646L43.1986 0.255048L45.2686 6.39305H50.9206L46.2766 9.50705L48.2386 15.231L43.1986 11.577L38.1946 15.231ZM55.4739 15.231L57.3999 9.50705L52.7559 6.39305H58.4439L60.4779 0.255048L62.5479 6.39305H68.1999L63.5559 9.50705L65.5179 15.231L60.4779 11.577L55.4739 15.231ZM72.7532 15.231L74.6792 9.50705L70.0352 6.39305H75.7232L77.7572 0.255048L79.8272 6.39305H85.4792L80.8352 9.50705L82.7972 15.231L77.7572 11.577L72.7532 15.231Z'
      fill='#FFA41C'
    />
  </svg>
);
export default ProductCardFilStars;
